<app-sidebar 
  [menuItems]="menuItems" 
  [callToAction]="callToAction"
  [footerItems]="footerItems"
  title="Provider">
</app-sidebar>



